import React from 'react';
import {convertirModena, sumaCompensacion, sumaIngreso} from "../../../shared/utils/utils";

export const DescripcionCompe = ({fields}) => {

    let compensacin = [];
    let compensacionOchenta = fields.length > 0 ? Math.round(fields[0].disponible)  : 0;
    let totalDeducciones = fields.length > 0 ? fields[0].total_deducciones : 0;
    const fondos = fields.length > 0 ? fields[0].total_fondos : 0;
    if (fields.length > 0) {
        compensacin = fields[0]['compensacion'] || [];
    }


    const ingreso = sumaIngreso(fields)
    const sumaCompensaciones = sumaCompensacion(fields);


    return (
        <table className="items-center w-full bg-transparent border-collapse">
            <thead>
            <tr>
                <th
                    className={
                        "px-6 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color"

                    }
                >
                    INGRESO
                </th>
                <th
                    className={
                        "px-6 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color"

                    }
                >
                    COMPENSACION (80%)
                </th>

                {fondos > 0 && <th
                    className={
                        "px-6 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color"

                    }
                >
                    FONDOS
                </th>}
                <th
                    className={
                        "px-6 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color"

                    }
                >
                    TOTAL DEDUCCIONES
                </th>
                <th
                    className={
                        "px-6 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color"

                    }
                >
                    DISPONIBLE
                </th>
                {(fields.length > 0 && compensacin.length > 0) && compensacin.map(((data, i) => <th
                    key={i}
                    className={
                        "px-6 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color"

                    }
                >
                    {data['descrip_abrev']}
                </th>))}
            </tr>
            </thead>
            <tbody>
            <tr>
                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left items-center">
                                <span className="ml-3 font-bold text-blueGray-600">
                                    {convertirModena(ingreso)}
                                </span>
                </td>
                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left items-center">
                                <span className="ml-3 font-bold text-blueGray-600">
                                    {convertirModena(compensacionOchenta)}
                                </span>
                </td>
                {fondos > 0 &&  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left items-center">
                                <span className="ml-3 font-bold text-blueGray-600">
                                    {convertirModena(fondos)}
                                </span>
                </td>}
                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left items-center">
                                <span className="ml-3 font-bold text-blueGray-600">
                                    {convertirModena(totalDeducciones)}
                                </span>
                </td>
                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left items-center">
                                <span className="ml-3 font-bold text-blueGray-600">
                                    {convertirModena(compensacionOchenta + fondos - totalDeducciones)}
                                </span>
                </td>
                {(fields.length > 0 && sumaCompensaciones.length > 0) && sumaCompensaciones.map(((data, i) => <td
                    className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left items-center"
                    key={i}><span
                    className="ml-3 font-bold text-blueGray-600">  {convertirModena(data[1])} </span>
                </td>))}
            </tr>
            </tbody>
        </table>
    );
};


